import { XMarkIcon } from "@heroicons/react/24/solid";
import {
  createProductVariant,
  updateProductVariant,
} from "../redux/slices/productSlice";
import { useDispatch } from "react-redux";

const Dropzone = ({ product, updateVariant }) => {
  const dispatch = useDispatch();
  const initialImages =
    product && updateVariant
      ? product?.data?.product_variants[0]?.img_urls
      : [];
  const uploadImages = (res) => {
    const allImages = res.info.files.map((item) => {
      return item.uploadInfo.secure_url;
    });

    const createVariantParam = {
      img_urls: allImages,
      product_id: product.data.id,
    };
    const updateVariantParam = {
      img_urls: allImages,
      product_variant_id:
        updateVariant && product?.data?.product_variants[0]?.id,
    };

    if (updateVariant && product?.data?.product_variants?.length > 0) {
      dispatch(updateProductVariant(updateVariantParam));
    } else {
      dispatch(createProductVariant(createVariantParam));
    }
  };

  const myCropWidget = window.cloudinary.createUploadWidget(
    {
      cloudName: "bitshub",
      uploadPreset: "ml_default",
      // cropping: true,
    },

    (error, result) => {
      if (!error && result && result.event === "queues-end") {
        uploadImages(result);
      }
    }
  );
  const removeFile = () => {};

  return (
    <section className="mt-10">
      <div className="flex items-center justify-center">
        <button
          onClick={() => myCropWidget.open()}
          className="mt-1 text-[12px] uppercase tracking-wider font-bold text-neutral-500 border border-primary rounded-md p-2 hover:bg-primary hover:text-white transition-colors"
        >
          open uploader
        </button>
      </div>

      {/* Accepted files */}
      <h3 className="title text-lg font-semibold text-neutral-600 mt-10 border-b pb-3">
        Product images
      </h3>
      <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-10">
        {updateVariant
          ? initialImages?.map((file, index) => (
              <li key={index} className="relative h-32 rounded-md shadow-lg">
                <img
                  src={file}
                  alt={file}
                  width={100}
                  height={100}
                  className="h-full w-full object-contain rounded-md"
                />
                <button
                  type="button"
                  className="w-7 h-7 border border-secondary-400 bg-secondary-400 rounded-full flex justify-center items-center absolute -top-3 -right-3 hover:bg-white transition-colors"
                  onClick={() =>
                    removeFile(!file.preview ? file : file.preview)
                  }
                >
                  <XMarkIcon className="w-5 h-5 fill-red hover:fill-secondary-400 transition-colors" />
                </button>
                <p className="mt-2 text-neutral-500 text-[12px] font-medium">
                  {index}
                </p>
              </li>
            ))
          : ""}
      </ul>
    </section>
  );
};

export default Dropzone;
